export class EnvironmentNames {
    public static LOCAL = 'LOCAL';
    public static DEVELOP = 'DEVELOP';
    public static STAGING = 'STAGING';
    public static PRODUCTION = 'PRODUCTION';
}
